import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';

export interface RegisterGiftCardFnPayload {
    expDate: string;
    cvc: string;
    cardNumber: string;
    country?: 'US' | 'CA';
}

export async function registerGiftCard(
    { clientSdk, appEventSdk }: DependenciesPayload,
    { cvc, expDate, cardNumber, country }: RegisterGiftCardFnPayload,
): Promise<{
    giftCardTokenId: string;
    giftCardAmount: number;
}> {
    try {
        let payload;
        if (!cvc && !expDate) {
            payload = {
                giftCard: {
                    incomm: {
                        cardIdentifier: cardNumber,
                    },
                },
            };
        } else {
            const expirationDateMonth = expDate.split('/')[0];
            const expirationDateYear = '20' + expDate.split('/')[1];
            payload = {
                giftCard: {
                    blackHawk: {
                        cvv2: cvc,
                        expirationDate:
                            expirationDateMonth + expirationDateYear,
                        cardNumber: cardNumber,
                    },
                },
            };
        }
        const response = await clientSdk.commerce.giftCard.registerGiftCard(
            payload,
            country,
        );
        appEventSdk.trackEvent({
            event: 'gift-card-applied',
            giftCardInfo: { giftCardApplied: true },
        });
        return {
            giftCardTokenId: response.giftCardTokenId,
            giftCardAmount: response.actualBalance.amount.value,
        };
    } catch (error: any) {
        if (
            error?.code ===
            'commerceTeam.giftCardServiceError.location_conflict'
        ) {
            throw new Error('COUNTRY_ERROR');
        } else if (
            error?.payload?.path ||
            error?.code ===
                'commerceTeam.giftCardServiceError.gift_card_bad_data'
        ) {
            throw new Error('BAD_DATA_RETURNED');
        } else if (
            error?.payload?.path ||
            error?.code ===
                'commerceTeam.giftCardServiceError.gift_card_already_redeemed'
        ) {
            throw new Error('ALREADY_REDEEMED');
        } else {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    }
}
